import SimpleWorkingAreaCard from '../SimpleWorkingAreaCard/SimpleWorkingAreaCard';

import './WorkingAreasList.scss';

function WorkingAreaList({areaToFilterOut, handleGoToWorkingAreaDetails, workingAreas, maxHeight}) {

  function renderWorkingAreas() {
    return workingAreas.map(workingArea => {
      if (!workingArea?.id || !workingArea?.description) return null;
      if (areaToFilterOut?.id === workingArea?.id) return null;
      return (
        <SimpleWorkingAreaCard
          key={workingArea.id}
          description={workingArea.description}
          workingAreaId={workingArea.id}
          handleGoToWorkingAreaDetails={handleGoToWorkingAreaDetails}
        />
      );
    });
  }

  if (!workingAreas) return <></>;

  return (
    <div className="working-areas-list" style={{
      maxHeight: maxHeight
    }}>
      {renderWorkingAreas()}
    </div>
  )
}

export default WorkingAreaList;
